import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { View } from "../../View";
import { palette } from "../../../theme/palette";
import { useSelector } from "react-redux";
import { simulationPercentagesSelector } from "../../../reducers/matrixProfile/selectors";
import clsx from "clsx";

const useStyles = makeStyles({
  container: {
    padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1.5rem",
  },
  percentageButtonContainer: {
    width: "20rem",
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    flexWrap: "wrap",
  },
  percentageButton: {
    color: palette.typography.white.high,
    backgroundColor: palette.darkGrey,
    padding: "0.5rem",
    border: palette.black,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: palette.translucentBlack,
    },
    cursor: "pointer",
    minWidth: "3rem",
    maxWidth: "3rem",
  },
  percentageButtonActive: {
    backgroundColor: palette.dpdRed,
  },
  defaultButton: {
    padding: "1rem",
    color: palette.typography.white.high,
    minWidth: "7rem",
    maxWidth: "7rem",
  },
});
export const SelectSimulatedOverlayContent = ({
  setModalValue,
  modalValue,
}) => {
  const styles = useStyles();
  const simulationPercentages = useSelector(simulationPercentagesSelector);

  const Buttons = () => {
    return simulationPercentages.map((percentage) => {
      return (
        <Button
          key={percentage}
          className={
            modalValue === percentage
              ? clsx(styles.percentageButton, styles.percentageButtonActive)
              : styles.percentageButton
          }
          variant={"contained"}
          onClick={() => {
            setModalValue(percentage);
          }}
        >
          {`${percentage}%`}
        </Button>
      );
    });
  };

  return (
    <View className={styles.container}>
      <Button
        className={
          modalValue === 0
            ? clsx(styles.defaultButton, styles.percentageButtonActive)
            : clsx(styles.percentageButton, styles.defaultButton)
        }
        variant={"contained"}
        onClick={() => {
          setModalValue(0);
        }}
      >
        Use Default
      </Button>
      <>
        <div>Increase default values by:</div>
        <View className={styles.percentageButtonContainer}>
          <Buttons />
        </View>
      </>
    </View>
  );
};
